module.exports = __webpack_public_path__ + "img/productos-ecommerce.57816203.jpg";